import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from "./components/AsyncComponent";
import AppliedRoute from './components/AppliedRoute'
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';

const AsyncAbout = asyncComponent(() => import('./containers/About'));
const AsyncHome = asyncComponent(() => import('./containers/Home'));
const AsyncNotFound = asyncComponent(() => import('./containers/NotFound'));
 
const AsyncLogin = asyncComponent(() => import('./containers/user/Login'));
const AsyncAccount = asyncComponent(() => import('./containers/user/Account'));
const AsyncForgotPassword = asyncComponent(() => import('./containers/user/ForgotPassword'));
 
const AsyncSubscriptions = asyncComponent(() => import('./containers/as/Subscriptions'));
const AsyncSubscriptionsList = asyncComponent(() => import('./containers/as/SubscriptionsList'));
const AsyncNewSubscription = asyncComponent(() => import('./containers/as/NewSubscription'));
const AsyncChannelEvents = asyncComponent(() => import('./containers/as/ChannelEvents'));
const AsyncWebEvents = asyncComponent(() => import('./containers/as/WebEvents'));
 
const AsyncActfGroupsList = asyncComponent(() => import('./containers/actf/ActfGroupsList'));
const AsyncActfGroups = asyncComponent(() => import('./containers/actf/ActfGroups'));
const AsyncNewActfGroup = asyncComponent(() => import('./containers/actf/NewActfGroup'));
 
const AsyncAlertsPocList = asyncComponent(() => import('./containers/alerts/AlertsPocList'));
const AsyncAlertsPoc = asyncComponent(() => import('./containers/alerts/AlertsPoc'));
const AsyncNewPoc = asyncComponent(() => import('./containers/alerts/NewPoc'));
const AsyncFlaggedAlertsPocList = asyncComponent(() => import('./containers/alerts/FlaggedAlertsPocList'));
const AsyncAlertsFilterList = asyncComponent(() => import('./containers/alerts/AlertsFilterList'));

const AsyncPanelsList = asyncComponent(() => import('./containers/panels/PanelsList'));
const AsyncPanel = asyncComponent(() => import('./containers/panels/Panel'));
const AsyncNewPanel = asyncComponent(() => import('./containers/panels/NewPanel'));
const AsyncPanelsJobsList = asyncComponent(() => import('./containers/panels/PanelsJobsList'));

const AsyncPDOrganizationsList = asyncComponent(() => import('./containers/providerdirectory/OrganizationsList'));
const AsyncPDOrganization = asyncComponent(() => import('./containers/providerdirectory/Organization'));
const AsyncNewPDOrganization = asyncComponent(() => import('./containers/providerdirectory/NewOrganization'));
const AsyncPDIgnoreList = asyncComponent(() => import('./containers/providerdirectory/IgnoreList'));
const AsyncNewPDIgnore = asyncComponent(() => import('./containers/providerdirectory/NewIgnore'));
const AsyncPDIgnore = asyncComponent(() => import('./containers/providerdirectory/Ignore'));

// service - relates to the allowedServices state variable used to indicate which services a user has access to

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/" exact component={AsyncHome} props={childProps}/>
    <UnauthenticatedRoute path="/login" exact component={AsyncLogin} props={childProps}/>
    <UnauthenticatedRoute path="/login/forgotpassword" exact component={AsyncForgotPassword} props={childProps}/>
	{/* Default Service - all authenticated users have acccess */}
	<AuthenticatedRoute path="/account" exact component={AsyncAccount} props={childProps} service="default"/>
	<AuthenticatedRoute path="/about" exact component={AsyncAbout} props={childProps} service="default"/>
	{/* Alerts Service */}
	<AuthenticatedRoute path="/alerts/filter" exact component={AsyncAlertsFilterList} props={childProps} service="Alerts"/>
	<AuthenticatedRoute path="/alerts/poc" exact component={AsyncAlertsPocList} props={childProps} service="Alerts"/>
	<AuthenticatedRoute path="/alerts/poc/new" exact component={AsyncNewPoc} props={childProps} service="Alerts"/>
	<AuthenticatedRoute path="/alerts/poc/flagged" exact component={AsyncFlaggedAlertsPocList} props={childProps} service="Alerts"/>
	<AuthenticatedRoute path="/alerts/poc/:id" exact component={AsyncAlertsPoc} props={childProps} service="Alerts" />
	{/* Autosubscribe Service */}
	<AuthenticatedRoute path="/as/subscriptions" exact component={AsyncSubscriptionsList} props={childProps} service="Autosubscribe"/>
	<AuthenticatedRoute path="/as/subscriptions/new" exact component={AsyncNewSubscription} props={childProps} service="Autosubscribe"/>
	<AuthenticatedRoute path="/as/subscriptions/:id" exact component={AsyncSubscriptions} props={childProps} service="Autosubscribe"/>
	<AuthenticatedRoute path="/as/events/channel" exact component={AsyncChannelEvents} props={childProps} service="Autosubscribe"/>
	<AuthenticatedRoute path="/as/events/web" exact component={AsyncWebEvents} props={childProps} service="Autosubscribe"/>
	{/* ACTF Service */}
	<AuthenticatedRoute path="/actf/groups" exact component={AsyncActfGroupsList} props={childProps} service="ACTF"/>
	<AuthenticatedRoute path="/actf/groups/new" exact component={AsyncNewActfGroup} props={childProps} service="ACTF"/>
	<AuthenticatedRoute path="/actf/groups/:id" exact component={AsyncActfGroups} props={childProps} service="ACTF"/>
	{/* Panels Service */}
	<AuthenticatedRoute path="/panels" exact component={AsyncPanelsList} props={childProps} service="Panels" />
	<AuthenticatedRoute path="/panels/new" exact component={AsyncNewPanel} props={childProps} service="Panels" />
	<AuthenticatedRoute path="/panels/jobs" exact component={AsyncPanelsJobsList} props={childProps} service="Panels" />
	<AuthenticatedRoute path="/panels/:id" exact component={AsyncPanel} props={childProps} service="Panels" />
	{/* Provider Directory Service */}
	<AuthenticatedRoute path="/providerdirectory/organizations" exact component={AsyncPDOrganizationsList} props={childProps} service="Provider Directory" />
	<AuthenticatedRoute path="/providerdirectory/organizations/new" exact component={AsyncNewPDOrganization} props={childProps} service="Provider Directory" />
	<AuthenticatedRoute path="/providerdirectory/organizations/:id" exact component={AsyncPDOrganization} props={childProps} service="Provider Directory" />
	<AuthenticatedRoute path="/providerdirectory/config/ignore" exact component={AsyncPDIgnoreList} props={childProps} service="Provider Directory" />
	<AuthenticatedRoute path="/providerdirectory/config/ignore/new" exact component={AsyncNewPDIgnore} props={childProps} service="Provider Directory" />
	<AuthenticatedRoute path="/providerdirectory/config/ignore/:id" exact component={AsyncPDIgnore} props={childProps} service="Provider Directory" />
	{/* Not Found */}
	<Route component={AsyncNotFound} />
	{/* Non-production routes below */}
	{process.env.REACT_APP_STAGE !== 'production' ? 
		<testing>
			
		</testing>
	: null}
    
  </Switch>
);






// WEBPACK FOOTER //
// ./src/Routes.js